import React from "react";
import PropTypes from "prop-types";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import SuiInput from "components/SuiInput";
import EditableField from "./editableField";

const BirthDateField = ({ value, isEditing, onEdit, onSave, onCancel, onChange }) => {
  return (
    <EditableField
      label="Fecha de Nacimiento"
      value={value}
      isEditing={isEditing}
      onEdit={onEdit}
      onSave={onSave}
      onCancel={onCancel}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value ? dayjs(value, "DD/MM/YYYY") : null}
          onChange={(newValue) => {
            onChange(newValue ? newValue.format("DD/MM/YYYY") : "");
          }}
          format="DD/MM/YYYY"
          renderInput={(params) => <SuiInput {...params} fullWidth />}
        />
      </LocalizationProvider>
    </EditableField>
  );
};

BirthDateField.propTypes = {
  value: PropTypes.string,
  isEditing: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default BirthDateField;
